<ng-container *transloco="let t">
  <ng-container *ngFor="let v of values$ | async">

    <div class="p-1-5 text-center {{v.result ? 'primary' : 'warn'}}">

      <div class="font-size-1-2">
        <label class="mr-1">{{t('outcome-report.outcomeLabel')}}: </label> <span class="font-weight-bold">{{v.result ?
          t('common.success') : t('common.fail')}}</span>
      </div>
      <div class="mt-1">
        <label class="mr-1">{{t('common.progress')}}:</label><span class="font-weight-bold">{{v.progress}}%</span>
        <label class="ml-3 mr-1">{{t('outcome-report.viewed')}}:</label><span class="font-weight-bold">{{v.viewed ?
          t('common.yes') : t('common.no')}}</span>
      </div>

    </div>
  </ng-container>
</ng-container>
